export const predefinedTags = [
  'Canceled',
  'Completed',
  'Not sent',
  'Ordered',
  'Pending',
  'Placed',
  'Purchased',
  'Received',
  'Shipped',
];
